import { useState, useRef, useEffect } from 'react';
import 'swiper/css';
import 'swiper/css/mousewheel';
import 'swiper/css/pagination';
import { Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperPage1 from './components/SwiperPage_1';
import SwiperPage2 from './components/SwiperPage_2';
import SwiperPage3 from './components/SwiperPage_3';
import SwiperPage4 from './components/SwiperPage_4';
import SwiperPage5 from './components/SwiperPage_5';
import './styles.css';

function LandingPageFeature() {
  const labels = ['Giới Thiệu', 'Dịch Vụ Organize', 'Dịch Vụ Bọc Hộp', 'Phụ Kiện Boardgame', 'Liên Hệ'];
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null); // Dùng ref để lưu instance Swiper

  useEffect(() => {
    // Reset class active của main khi activeIndex thay đổi
    const mainElement = document.querySelector('.main');
    if (mainElement) {
      mainElement.classList.remove('active');
      setTimeout(() => {
        mainElement.classList.add('active');
      }, 0); // Set timeout để đảm bảo thao tác thêm class sau khi class đã bị xóa
    }
  }, [activeIndex]); // Chạy khi activeIndex thay đổi

  return (
    <div className="main">
      {/* Custom Pagination (đặt ngoài Swiper) */}
      <div className="custom-pagination">
        {labels.map((label, index) => (
          <button
            key={index}
            className={`swiper-pagination-bullet ${activeIndex === index ? 'swiper-pagination-bullet-active' : ''}`}
            onClick={() => {
              if (swiperRef.current && swiperRef.current.slideTo) {
                swiperRef.current.slideTo(index); // Gọi slideTo() đúng cách
              }
            }}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="swiper-container">
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper; // Lưu instance Swiper vào ref
          }}
          direction="vertical"
          slidesPerView={1}
          speed={800}
          mousewheel={{ forceToAxis: true, sensitivity: 1 }}
          modules={[Mousewheel]}
          breakpoints={{
            0: { direction: 'horizontal', slidesPerView: 1, spaceBetween: 20 },
            1025: { direction: 'vertical' },
          }}
          observer={true}
          observeParents={true}
          onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        >
          <SwiperSlide>
            <SwiperPage1 id={1} isActive={activeIndex === 0} />
          </SwiperSlide>
          <SwiperSlide>
            <SwiperPage2 id={2} isActive={activeIndex === 1} />
          </SwiperSlide>
          <SwiperSlide>
            <SwiperPage3 id={3} isActive={activeIndex === 2} />
          </SwiperSlide>
          <SwiperSlide>
            <SwiperPage4 id={4} isActive={activeIndex === 3} />
          </SwiperSlide>
          <SwiperSlide>
            <SwiperPage5 id={5} isActive={activeIndex === 4} />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
}

export default LandingPageFeature;
